import logger from './utils/logger';
// export const BACKEND_URL = 'https://api.beta.vortic.link/';
export const BACKEND_URL = process.env.API_URL;
export const API_ENV = process.env.API_ENV;
export const CMS_URL = process.env.CMS_URL || 'https://cms.vortic.art/';

// Feature flag: hide the bookmark/favourite buttons (exhibition cards, exhibition
// detail page, and gallery/museum/curator/collective/artist detail headers).
// Set to true to bring them back.
export const SHOW_FAVOURITE_BUTTON = false;

// console.log('API_URL = ', process.env.API_URL)
export const IS_PRODUCTION_API_ENV = API_ENV === 'production';
// logger.log('process.env.API_URL = ', process.env.API_URL);
// logger.log('BACKEND_URL = ', BACKEND_URL);
